import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import './index.less'

export default ({ text }) => {

  return (
    <div className="line-tip-box mb-12">
      <InfoCircleOutlined className="tip-icon" />
      <div>
        {text.length > 0 && (
          text.map((item, idx) =>
            <p key={idx}>{item}</p>
          )
        )}
      </div>
    </div>
  )
}